import { toKebabCase } from './string-utils';
import { docLinkMap } from './docLinkMap';

export const setComponentAttributes = (options: { element: HTMLElement; key: string; value: string | boolean }) => {
  const { element, key, value } = options;
  const attribute = toKebabCase(key);
  if (typeof value === 'boolean') {
    if (value) {
      element.setAttribute(attribute, ''); // Reflect as attribute
    } else {
      element.removeAttribute(attribute); // Remove attribute
    }
  } else {
    element.setAttribute(attribute, String(value)); // Reflect as attribute
  }
};

/*
 * Chromatic sometimes cuts off part of a component vertically in its snapshot tests.
 * When that happens, add this function as a decorator to the affected component's stories to fix the issue.
 * https://www.chromatic.com/docs/troubleshooting-snapshots/#common-snapshot-rendering-issues
 */
export const createStoryWrapper =
  ({ height = 60 }: { height?: number }) =>
  (Story: () => HTMLElement) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'story-wrapper';
    const style = document.createElement('style');
    style.textContent = `
    .story-wrapper {
      height: ${height}px;
      display: flex;
      align-items: center;
    }
  `;
    document.head.appendChild(style);
    wrapper.appendChild(Story());
    return wrapper;
  };

export function processMarkdown(content: string): string {
  // Regular expression to match markdown links
  // This regex looks for [text](link) patterns
  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;

  return content.replace(linkRegex, (match: string, linkText: string, linkUrl: string): string => {
    // Check if this link is in our mapping
    if (linkUrl in docLinkMap) {
      // Replace with Storybook link
      return `[${linkText}](${docLinkMap[linkUrl as keyof typeof docLinkMap]})`;
    }

    // If not in mapping, return original link
    if (!linkUrl.startsWith('http')) {
      console.error(`Link not found in docLinkMap: ${linkUrl}`);
    }
    return match;
  });
}
